import { Flag } from "lucide-react";
import { useT } from "../i18n";

const daysUntil = (date) => Math.ceil((new Date(date) - Date.now()) / 86400000);
const countdownLabel = (r, t) => {
  if (!r.date) return t("race_date_tbc");
  const start = daysUntil(r.date), end = daysUntil(r.end_date || r.date);
  if (start > 0) return t("cd_days", start);
  return end >= 0 ? t("cd_today") : t("cd_over");
};

export const RaceCountdown = ({ races, myRace }) => {
  const { t } = useT();
  const dated = races.filter((r) => (r.date || r.id === myRace) && r.id !== "other").sort((a, b) => (a.id === myRace ? -1 : b.id === myRace ? 1 : new Date(a.date) - new Date(b.date)));
  if (!dated.length) return null;
  return (
    <div className="-mx-5 mt-5 flex gap-2 overflow-x-auto px-5 pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-testid="race-countdown">
      {dated.map((r) => {
        const mine = r.id === myRace;
        return (
          <div
            key={r.id}
            data-testid={`race-countdown-${r.id}`}
            className={`flex shrink-0 items-center gap-3 rounded-[4px] border px-3 py-2 ${mine ? "border-rox-orange bg-rox-orange text-rox-black" : "border-rox-line bg-rox-panel"}`}
          >
            {mine && <Flag size={14} strokeWidth={2.5} />}
            <div>
              <p className={`text-[10px] font-semibold uppercase tracking-[0.16em] ${mine ? "text-rox-black/70" : "text-rox-muted"}`}>{r.name.replace(/^.*HYROX\s*/i, "") || r.name}</p>
              <p className={`font-display leading-none ${r.date ? "text-xl" : "text-sm"}`}>{countdownLabel(r, t)}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
